import Head from 'next/head';
import React from 'react';

interface MetaProps {
  title?: string;
  keyword?: string;
  desc?: string;
  isListSyncDomain?: boolean;
}
const Meta: React.FC<MetaProps> = ({
  title,
  keyword,
  desc,
  isListSyncDomain
}) => {
  const favicon32 = isListSyncDomain
    ? '/favicon/listsync-32x32.png'
    : '/favicon/favicon-32x32.png';
  const favicon16 = isListSyncDomain
    ? '/favicon/listsync-16x16.png'
    : '/favicon/favicon-16x16.png';
  const appleTouchIcon = isListSyncDomain
    ? '/favicon/listsync-apple-touch-icon.png'
    : '/favicon/apple-touch-icon.png';

  return (
    <Head>
      <title>{title}</title>
      {/* 移动端视口配置 - 防止点击屏幕放大 */}
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      />
      {/* Favicon */}
      <link rel="apple-touch-icon" sizes="180x180" href={appleTouchIcon} />
      <link rel="icon" type="image/png" sizes="32x32" href={favicon32} />
      <link rel="icon" type="image/png" sizes="16x16" href={favicon16} />

      <meta name="description" content={desc} />
      <meta name="keyword" content={keyword} />
    </Head>
  );
};

export default Meta;
